import { useState, useEffect } from 'react';
import { View, Platform } from 'react-native';
import axios from 'axios';
import PublicRoutes from './public';



import ErrorBottomSheet from '../sharedComponents/ErrorBottomSheet/ErrorBottomSheet';
import {  clearLMSData, logout, updateLinkedApplication, updateUserDetails, userAuthenticated } from '../store/slices/authSlice';
import { baseAmplitudeConfig, baseUrl, baseUrlConfig, endpoints } from '../api/apis';


import {useAppDispatch , useAppSelector } from '../store/hooks'
import {showErrorSheet} from '../store/slices/errorSlice'
import { APPLICATION_STATUS, getParameters, getParamsLink, parseParameters, parseURL, removeQueryParams, removeUrlWithoutReload, setAppHeader } from '../utils/utils';
import { updatePartnerParams } from '../store/slices/platformSlice';
import { LENDER_ID, PLATFORM_NAME } from '@app/types/regix';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { initAmplitude, trackEvent } from '@app/utils';
import useSingleRemoteConfig from '@app/hooks/useSingleRemoteConfig';
import handleApiErr from '@app/helper/handleApiErr';
import { updateBFLCheck, updateisLMSUser, updateIsLoanCompleted, updateLMSUserDashboard } from '@app/store/slices/commonSlice';
import * as Sentry from '@sentry/react-native';
import VoltLogoNew from '../../assets/Icons/VoltLogoNew';
import { clearAsyncStorageExcept, deleteAllCookies } from '@app/helper/logout';
import { useTheme } from '@shopify/restyle';
import { Theme } from '@app/theme';
import PrivateRoutes from './private';
import { store } from '@app/store/newstore';
import PageLoader from '@app/sharedComponents/PageLoader/PageLoader';


let crashlytics: typeof import("@react-native-firebase/crashlytics").default | undefined;
if (typeof window === "undefined") {
  crashlytics = require("@react-native-firebase/crashlytics").default;
}


export const renewApplicationApi = async (payload: { applicationId: string }) => {

  let applicationId = payload.applicationId;
  let applicationIdStored = await AsyncStorage.getItem('application_id')

  if (applicationIdStored) {
      applicationId = applicationIdStored;
  }

  const response = await axios.get(endpoints.renewAppliction + applicationId);
  return response.data;

}

export default function AppRoutes() {
  const {auth, platformParams} = useAppSelector(state => state);

  const {colors} = useTheme<Theme>()

  const [isLoading , setIsLoading] = useState(true)
  const [showSplashScreen , setShowSplashScreen] = useState(false)
  const isProd = baseUrl === baseUrlConfig['production'];
  const errorSheetDetail = useAppSelector(state => state.errorSheet);
  const dispatch = useAppDispatch();
  const url = Platform.OS === 'web' ?  window.location.href : ''
  const params = Platform.OS === 'web' ?  parseURL(url) : {}
  const isPlj = params?.isPLJ;
  const ssoToken = params?.ssoToken;
  const plkTK = params?.plkTK;
  const [tokenFromStorage , setTokenFromStorage] = useState<null | string>(null)
  const {configValue:callData} =  useSingleRemoteConfig('contact_support_number_pre_dashboard')
  const {configValue:lmsCallData} =  useSingleRemoteConfig('contact_support_number')
  const {configValue:waData} = useSingleRemoteConfig('contact_support_number_whatsapp')
  const isBFLFirebase = useAppSelector((state) => state.firebaseParams?.bfl_shutdown);
  const isLasFlowEnabled = useAppSelector((state) => state.firebaseParams?.is_Las_Flow_Enabled);
  const isBFLfromFirebaseBoolean = isBFLFirebase && isBFLFirebase === 'true';


  const fetchUserDetails = async () => {
    const url = endpoints.userInfo;

    try {
      const res = await axios.post(url, { onboardingPartnerCode: params?.partnerReferralCode ?? '' });
      if(Platform.OS !== 'web' && crashlytics){
        crashlytics().setUserId(res?.data?.linkedApplications[0]?.accountId)
        crashlytics().setAttribute('phoneNumber', res?.data?.user?.phoneNumber)
      }
      Sentry?.setUser({ phoneNumber: res.data.user?.phoneNumber });
      Sentry?.setUser({ username: res?.data?.linkedBorrowerAccounts[0]?.accountId });
      initAmplitude({userId : res?.data?.linkedApplications[0]?.accountId, token: baseAmplitudeConfig});
      dispatch(clearLMSData());
      if(!isPlj) {
         if(ssoToken){
          dispatch(updateUserDetails(res?.data));
         }
         else {
          const currentApplicationId = params?.applicationId ? params?.applicationId : res?.data?.linkedApplications[0]?.applicationId;
          await AsyncStorage.removeItem('application_id');
          removeUrlWithoutReload('applicationId');
          const renewAppliationResponse = await renewApplicationApi({applicationId:currentApplicationId});
          dispatch(updateUserDetails(res?.data));
          dispatch(updateLinkedApplication(renewAppliationResponse));
         }
      } else if(params?.applicationId && isLasFlowEnabled){
          try {
            dispatch(updateUserDetails(res?.data));
            const renewAppliationResponse = await renewApplicationApi({applicationId:params?.applicationId});
            dispatch(updateLinkedApplication(renewAppliationResponse));
            AsyncStorage.setItem('application_id', params?.applicationId);
            removeUrlWithoutReload('applicationId');
          } catch (error) {
            console.log('error',error)
            dispatch(updateUserDetails(res?.data));
          }
        }
      else {
          dispatch(updateUserDetails(res?.data));
      }
      const creditId = res?.data?.linkedCredits[0]?.creditId || null;
      const currentStepName = res?.data?.linkedApplications[0]?.currentStepId
      if (creditId !== null || currentStepName === null) {
        dispatch(updateisLMSUser({ isLMSUser: true }));
      }
      else{
        dispatch(updateisLMSUser({ isLMSUser: false }));
      }
      const currentUserDetails = store.getState().auth.userDetails;
      if(currentUserDetails?.linkedApplications[0]?.applicationState === APPLICATION_STATUS.COMPLETED && isLasFlowEnabled) {
        dispatch(updateIsLoanCompleted({ isLoanCompleted: true }));
        dispatch(updateLMSUserDashboard({isLMSUserDashboard:true}))
      } else {
        dispatch(updateIsLoanCompleted({ isLoanCompleted: false }));
      }
    } catch (err : any) {
      if (handleApiErr(err)) {
        dispatch(
          showErrorSheet({
            isErrorSheetVisible: true,
            errorMessage: err?.data?.message,
            closeOnBackdropPress: true,
            errorType: err?.data?.voltErrorCode || err?.data?.statusCode,
            errorHeading: err?.data?.header,
          }),
        );
      }
    } finally {
      setIsLoading(false)
    }

  };


  const checkUserAuthentication = async () => {
    try {
      let token: string | null = null;
  
      if (Platform.OS === "web") {
        const params = parseURL(window.location.href);
  
        const { ssoToken, t: short_token, plkTK,platform,trackingId } = params;
        let _url2 = removeQueryParams(url, ['t', 'plj']);

        if (platform === 'PHONEPE') {
          _url2 += '&showHome=false';
        }
  
        if (ssoToken) {
          deleteAllCookies();
          const res = await axios.post(endpoints.getAuthToken, { ssoToken });
          token = res?.data?.authToken;
        }
        else if (short_token) {
          deleteAllCookies();
          setAppHeader(short_token);
          window.parent.postMessage(`PLJ_SHORT_TOKEN_TO_LONG_TOKEN_GENERATION_INITIATED`, '*');
          try {
            const res = await axios.post(endpoints.refreshToken);
            token = res?.data?.jwt;
            if (platform) {
              await AsyncStorage.setItem('access_token', res.data.jwt, () => {
                const domain = window?.location?.origin;
                window.open(`${domain}/partnerPlatform${getParamsLink(_url2)}`, '_self');
              });
            } else {
              await AsyncStorage.setItem('access_token', res.data.jwt, () => {
                const domain = window?.location?.origin;
                window.open(`${domain}/${getParamsLink(_url2)}`, '_self');
              });
            }
          } catch (error) {
            console.log('error',error)
          }
          finally {
            window.parent.postMessage(`PLJ_SHORT_TOKEN_TO_LONG_TOKEN_GENERATION_COMPLETED`, '*');
          }
        }
        else if (plkTK) {
          deleteAllCookies();
          await clearAsyncStorageExcept([
            'first_time',
            'show_new_arch',
            'show_lms_revamp',
            'remoteConfig',
            'biometric_permission'
          ]);
          setAppHeader(plkTK);
          window.parent.postMessage(
            `PLJ_SHORT_TOKEN_TO_LONG_TOKEN_GENERATION_INITIATED`,
            '*'
          );
        
          try {
            const res = await axios.post(endpoints.refreshToken);
        
            if (res.status === 200 && res?.data?.jwt) {
              token = res.data.jwt;
        
              window.parent.postMessage(
                `PLJ_SHORT_TOKEN_TO_LONG_TOKEN_GENERATION_COMPLETED`,
                '*'
              );
              removeUrlWithoutReload('plkTK');
            } else {
              trackEvent("PLJ_SHORT_TOKEN_TO_LONG_TOKEN_GENERATION_FAILED", {
                trackingId: trackingId,
                failedCause: 'Failed to get new short JWT from response',
              });
            }
        
          } catch (err) {
            console.log('plkTK refresh error', err);
          }
        }
        else {
          const cookie = document.cookie
            .split(";")
            .find((item) => item.trim().startsWith("access_token="));
  
          token = cookie?.split("=")[1] || null;
        }
      }
  
      if (!token) {
        token = await AsyncStorage.getItem("access_token");
      }
  
      if (!token) {
        Sentry.captureMessage("Auth token missing", {
          level: "warning",
        });
        dispatch(logout());
        return;
      }
  
      setAppHeader(token);
      setTokenFromStorage(token);
  
      await fetchUserDetails();
  
    } catch (error) {
      console.log("auth error", error);
    } finally {
      setIsLoading(false);
    }
  };


  useEffect(()=>{
    checkUserAuthentication()
  },[auth?.accessToken, auth.isAuthenticated, dispatch])

  useEffect(() => {
      dispatch(updateBFLCheck({ isBFLLoan: auth.userDetails?.linkedCredits[0]?.lendingPartnerId?.toLowerCase() === LENDER_ID.BAJAJ.toLowerCase() && isBFLfromFirebaseBoolean }));
  } ,[auth.userDetails?.linkedCredits[0]?.lendingPartnerId , isBFLfromFirebaseBoolean])


  useEffect(()=>{
    if (Platform.OS === 'web') {
      document.title = 'Volt - Unlock cash from your mutual funds saving'; // Explicitly set the title
    }
      if(!auth.isAuthenticated || auth?.userDetails===null) {
        return
      };
      const creditId = auth?.userDetails?.linkedCredits[0]?.creditId || null;
      const currentStepName = auth?.userDetails?.linkedApplications[0]?.currentStepId
      const isLmsUser =  creditId !== null || currentStepName === null
      const callNumber = isLmsUser ? lmsCallData : callData
      if(callNumber){
      let updateData = callNumber
       if(Platform.OS === 'web'){
        const params = parseURL(window?.location?.href);
        updateData = params?.callData || callNumber
       }
        dispatch(updatePartnerParams({callData:updateData}))
      }
      if(waData){
        let updateData = waData
         if(Platform.OS === 'web'){
          const params = parseURL(window?.location?.href);
          updateData = params?.waData || waData
         }
          dispatch(updatePartnerParams({waData:updateData}))
        }

  },[callData,waData ,lmsCallData,auth?.isAuthenticated,auth?.userDetails])


  useEffect(() => {
    let params = {};
    if(Platform.OS === 'web'){
      params = parseURL(window?.location?.href);
    }

    if(Platform.OS === 'web'){
      const url =  window.location.href;
      const params = parseParameters(window.location.href);
      const isPartnerPlatform = url.toLowerCase().includes('partnerplatform');
      const isMarketing = url.toLowerCase().includes('marketing');
      const isKYCRedirect = url.includes('bajajKyc');
      const isIframe = params?.isIframe;
      const platform = params?.platform;
      const isfromTDL = platform === PLATFORM_NAME.TDL
      const isFromDsp = platform === LENDER_ID.DSP
      const isFromBajaj = platform === LENDER_ID.BAJAJ
      const isFromPhonePe = platform === PLATFORM_NAME.PHONEPE
      const showVoltDefaultHeader = !((isMarketing || isIframe) || platform ==="REDVISION" || platform==="JUPITER")
      const obj={showVoltDefaultHeader,...params,isPartnerPlatform,isFromPhonePe,isFromDsp, isFromBajaj,isMarketing,isKYCRedirect,isfromTDL}
      dispatch(updatePartnerParams(obj))
    }
  }, [auth?.accessToken, auth.isAuthenticated, dispatch]);

  


  useEffect(() => {
    if (Platform.OS !== 'web') return;

    const { isIframe, isCheckLimitMFC, leadtoken, trackingId, platform } = params;

    const isPartnerPlatform = url.toLowerCase().includes('partnerplatform');
    const isMarketing = url.toLowerCase().includes('marketing');
    const isKYCRedirect = url.includes('bajajKyc');
    const isfromTDL = platform === PLATFORM_NAME.TDL;
    const isFromDsp = platform === LENDER_ID.DSP;
    const isFromBajaj = platform === LENDER_ID.BAJAJ;
    const isFromTata = platform === LENDER_ID.TATA;
    const isFromPhonePe = platform === PLATFORM_NAME.PHONEPE;
    const showVoltDefaultHeader = !((isMarketing || isIframe) || platform === "REDVISION" || platform === "JUPITER");
    const obj = {
      showVoltDefaultHeader,
      ...params,
      isPartnerPlatform,
      isFromPhonePe,
      isFromDsp,
      isFromBajaj,
      isFromTata,
      isMarketing,
      isKYCRedirect,
      isfromTDL,
    };

    dispatch(updatePartnerParams(obj));

    if (isCheckLimitMFC && leadtoken) {
      AsyncStorage.setItem('lead_token', leadtoken);
      AsyncStorage.setItem('CONTEXT', 'VIEW_DETAIL');
      navigation.navigate("CHECK_LIMIT_MFC_INIT", { isCheckLimitMFC });
    } 

    const messageHandler = async (event: MessageEvent) => {
      try {
        if (event.data && event.data.jwt) {
          const response = await axios.post(endpoints.refreshToken, {});
          if (response?.data?.jwt) {
            setAppHeader(response.data.jwt);
            window.parent.postMessage(`PLJ_SHORT_TOKEN_TO_LONG_TOKEN_GENERATION_COMPLETED`, '*');
          } else {
            trackEvent("PLJ_SHORT_TOKEN_TO_LONG_TOKEN_GENERATION_FAILED", {
              trackingId,
              failedCause: 'Failed to get new JWT from response',
            });
          }
        }
      } catch (error) {
        trackEvent("PLJ_SHORT_TOKEN_TO_LONG_TOKEN_GENERATION_FAILED", {
          trackingId,
          failedCause: 'Error processing message event',
        });
      }
    };
      window.addEventListener('message', messageHandler);
      window.parent.postMessage(`PLJ_SHORT_TOKEN_TO_LONG_TOKEN_GENERATION_INITIATED`, '*');

    return () => {
        window.removeEventListener('message', messageHandler);
    };
  }, []);






  useEffect(() => {
    // initialiseing the amplitude for signedout routes
    initAmplitude({ userId: '', token: baseAmplitudeConfig })

    if (Platform.OS === 'web') {
      const url = window.location.href;
      const params = getParameters(url);

      const digio_autopay_response = params?.digio_autopay_response;
      const digio_agreement_response = params?.digio_agreement_response;
      const kyc_response = params?.kyc_response;
      const partner_platform = url.toString().includes('partnerPlatform') || url.toString().includes('partnerplatform');
      const tataMandateCallback = url.toString().includes('mandateCallback');

      if (digio_autopay_response || tataMandateCallback || kyc_response || digio_agreement_response || partner_platform) {
        setShowSplashScreen(false)
      } else {
        setShowSplashScreen(true)
      }
    }
  }, [])

  if (isLoading) {
    return (
      <View style={{ backgroundColor: showSplashScreen ? colors['bg-action-primary'] : colors['bg-surface-primary'], flex: 1, alignItems: 'center', justifyContent: 'center' }}>
        {showSplashScreen ? <VoltLogoNew /> : <PageLoader />}
      </View>
    )
  }

  return (
    <>
      {auth?.isAuthenticated && tokenFromStorage && auth?.userDetails ? (
        <PrivateRoutes userDetails={auth?.userDetails}  />
      ) : (
        <PublicRoutes />
      )}
      {errorSheetDetail?.isErrorSheetVisible && <ErrorBottomSheet />}
    </>
  );
}
